import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import ExportItemForm from "./ExportItemForm";
import {
  deleteExportItem,
  getExportItemList,
} from "../../api/exports";

// The granular, per-row-modal item grid for an Export — lives on the detail page
// (Frontend/src/screens/Exports/ExportDetailScreen.js), mirroring
// PODetailMaterialModalCrud.js for Purchase Orders.
export default function CrudExportItems({ exportId, companyId, onItemsChanged, isAgsExport }) {
  const fetchExportItems = async (queryParams) => {
    return await getExportItemList({
      ...queryParams,
      exportId,
      companyId,
    });
  };

  const handleDelete = async (id) => {
    await deleteExportItem(id);
    if (onItemsChanged) onItemsChanged();
  };

  const columns = [
    {
      field: "clientPurchaseOrder",
      headerName: "Orden de compra",
      flex: 0.2,
      valueGetter: (value, row) =>
        row.clientPurchaseOrder?.code || "",
    },
    {
      field: "itemQuantity",
      headerName: "Cantidad",
      flex: 0.1,
      type: "number",
    },
    {
      field: "unitPrice",
      headerName: "Precio unitario",
      flex: 0.1,
      type: "number",
    },
    {
      field: "palletQuantity",
      headerName: "Pallets",
      flex: 0.1,
      type: "number",
    },
    {
      field: "tariffFraction",
      headerName: "Fracción",
      flex: 0.15,
      valueGetter: (value, row) =>
        row.tariffFraction
          ? `${row.tariffFraction.code || ""}`.trim()
          : "",
    },
    {
      field: "masterNetWeight",
      headerName: "Peso neto/caja",
      flex: 0.1,
      type: "number",
    },
    {
      field: "masterGrossWeight",
      headerName: "Peso bruto/caja",
      flex: 0.1,
      type: "number",
    },
    {
      // System.Text.Json's camelCase policy only lowercases the leading character,
      // so "RFID" (all-caps) serializes as "rFID", not "rfid" — see the same
      // pSYear/psYear quirk already handled in ExportItemForm.js.
      field: "rFID",
      headerName: "RFID",
      flex: 0.1,
      valueGetter: (value, row) => (row.rFID ? row.rFID.name : ""),
    },
  ];

  return (
    <Box width="100%">
      {exportId && (
        <LGModalCrud
          props={{
            actions: ["create", "update", "delete"],
            data: { exportId, companyId },
            fetchFunction: fetchExportItems,
            deleteFunction: handleDelete,
            serverDrivenPagination: false,
            columns,
            addModalData: {
              header: "Agregar item de exportación",
              body: (
                <ExportItemForm exportId={exportId} companyId={companyId} onItemsChanged={onItemsChanged} isAgsExport={isAgsExport} />
              ),
            },
            editModalData: {
              header: "Editar item de exportación",
              body: (
                <ExportItemForm exportId={exportId} companyId={companyId} onItemsChanged={onItemsChanged} isAgsExport={isAgsExport} />
              ),
            },
          }}
        />
      )}
    </Box>
  );
}
